export default class MailDomain {
  name!: string | null;

  constructor() {
    this.name = null;
  }
}
